import PlaceOnboardingDialog from "components/PlaceOnboardingFlowDiaalog";
import { useSelector, useDispatch } from "react-redux";
import { closeOnboarding } from "store/slice/globalControl/globalControlSlice";

const GlobalDialogs = () => {
  const dispatch = useDispatch();
  const placeList = useSelector((state) => state.places.placesList) || [];

  const { open, placeId } = useSelector((state) => state.ui.onboardingDialog);

  return (
    <PlaceOnboardingDialog
      open={open}
      onClose={() => dispatch(closeOnboarding())}
      placeList={placeList}
      selectedPlaceId={placeId}
    />
  );
};

export default GlobalDialogs;
